/*
================================================
Des mixins relatives aux intercepteur Axios (voir main.js)
https://fr.vuejs.org/v2/guide/mixins.html
================================================
*/
var InterceptorMixin = {
    created() {
    },

    data: function () {
        return {}
    },
    methods: {


        /**
         * Retourne true si la réponse doit-être interceptée par l'intercepteur Axios
         * @param response (Axios)
         * @param auth
         * @returns {boolean}
         */
        shouldBeIntercepted: function (response, auth) {

            if (this.InterceptBadCredentials(response, auth) || this.InterceptExpiredJwt(response, auth)) {
                return true
            } else {
                return false
            }
        },

        /**
         * Retourne true si la réponse doit-être interceptée par l'intercepteur Axios (voir main.js) pour cause de réponse : 401 'Expired JWT Token'
         *
         * @param response (axios)
         * @param auth l'objet this.$auth
         * @returns {boolean}
         */
        InterceptExpiredJwt: function (response, auth) {

            if (response != undefined && response.status == 401 && response.data.message == 'Expired JWT Token' && auth.isAuthenticated()
            ) {
                return true
            } else {
                return false
            }
        },

        /**
         * Retourne true si la réponse doit-être interceptée par l'intercepteur Axios (voir main.js) pour cause de réponse : 401 'Bad credentials'
         *
         * @param response (axios)
         * @param auth
         * @returns {boolean}
         */
        InterceptBadCredentials: function (response, auth) {

            if (response != undefined && response.status == 401 && response.data.message == 'Bad credentials' && auth.isAuthenticated()
            ) {
                return true
            } else {
                return false
            }
        }
    }

}

export default  InterceptorMixin
